// translations/RankingAndSorting.js
export default {
    en: {
        sorting: {
            dropdownInstruction: "Sort items using the dropdown menu",
            specifyBucket: "Please specify the bucket where you would like each option to be placed:",
            instruction: "Drag options in the box below to sort"
        },
        ranking: {
            instruction: {
                responsive: "Select or drag the options below into this box to start ranking them",
                default: "Select or drag the options into this box to start ranking them"
            }
        },
        allOptionsRanked: "All options have been ranked",
        allOptionsSorted: "All options have been sorted",
        select: {
            bucket: "Please select bucket",
            default: "Please select"
        },
        action: {
            processOption: "Process option",
            moveUp: "Move option up",
            moveDown: "Move option down",
            removeOption: "Remove option"
        }
    },
    in: {
        sorting: {
            dropdownInstruction: "Urutkan item menggunakan menu tarik-turun",
            specifyBucket: "Harap tentukan bucket tempat Anda ingin menempatkan setiap opsi:",
            instruction: "Seret opsi ke kotak di bawah untuk mengurutkan"
        },
        ranking: {
            instruction: {
                responsive: "Pilih atau seret opsi di bawah ke kotak ini untuk mulai memberi peringkat",
                default: "Pilih atau seret opsi ke kotak ini untuk mulai memberi peringkat"
            }
        },
        allOptionsRanked: "Semua opsi telah diberi peringkat",
        allOptionsSorted: "Semua opsi telah diurutkan",
        select: {
            bucket: "Silakan pilih bucket",
            default: "Silakan pilih"
        },
        action: {
            processOption: "Proses opsi",
            moveUp: "Pindahkan opsi ke atas",
            moveDown: "Pindahkan opsi ke bawah",
            removeOption: "Hapus opsi"
        }
    },
    fr: {
        sorting: {
            dropdownInstruction: "Triez les éléments en utilisant le menu déroulant",
            specifyBucket: "Veuillez spécifier le compartiment où vous souhaitez placer chaque option :",
            instruction: "Faites glisser les options dans la case ci-dessous pour trier"
        },
        ranking: {
            instruction: {
                responsive: "Sélectionnez ou faites glisser les options ci-dessous dans cette case pour commencer à les classer",
                default: "Sélectionnez ou faites glisser les options dans cette case pour commencer à les classer"
            }
        },
        allOptionsRanked: "Toutes les options ont été classées",
        allOptionsSorted: "Toutes les options ont été triées",
        select: {
            bucket: "Veuillez sélectionner un compartiment",
            default: "Veuillez sélectionner"
        },
        action: {
            processOption: "Traiter l'option",
            moveUp: "Déplacer l'option vers le haut",
            moveDown: "Déplacer l'option vers le bas",
            removeOption: "Supprimer l'option"
        }
    },
    de: {
        sorting: {
            dropdownInstruction: "Sortieren Sie Elemente mit dem Dropdown-Menü",
            specifyBucket: "Bitte geben Sie den Behälter an, in den jede Option gelegt werden soll:",
            instruction: "Ziehen Sie die Optionen in das untenstehende Feld, um sie zu sortieren"
        },
        ranking: {
            instruction: {
                responsive: "Wählen Sie die Optionen aus oder ziehen Sie sie in dieses Feld, um mit der Bewertung zu beginnen",
                default: "Ziehen Sie die Optionen in dieses Feld, um mit der Bewertung zu beginnen"
            }
        },
        allOptionsRanked: "Alle Optionen wurden bewertet",
        allOptionsSorted: "Alle Optionen wurden sortiert",
        select: {
            bucket: "Bitte wählen Sie einen Behälter aus",
            default: "Bitte auswählen"
        },
        action: {
            processOption: "Option verarbeiten",
            moveUp: "Option nach oben bewegen",
            moveDown: "Option nach unten bewegen",
            removeOption: "Option entfernen"
        }
    },

    zh: {
        sorting: {
            dropdownInstruction: "使用下拉菜单对项目进行排序",
            specifyBucket: "请指定要将每个选项放入的类别：",
            instruction: "将选项拖到下面的框中以进行排序"
        },
        ranking: {
            instruction: {
                responsive: "选择或将下面的选项拖到此框中以开始排名",
                default: "选择或将选项拖到此框中以开始排名"
            }
        },
        allOptionsRanked: "所有选项均已排名",
        allOptionsSorted: "所有选项均已排序",
        select: {
            bucket: "请选择类别",
            default: "请选择"
        },
        action: {
            processOption: "处理选项",
            moveUp: "向上移动选项",
            moveDown: "向下移动选项",
            removeOption: "移除选项"
        }
    },

    nl: {
        sorting: {
            dropdownInstruction: "Sorteer items met behulp van het keuzemenu",
            specifyBucket: "Geef de bucket op waarin je elke optie wilt plaatsen:",
            instruction: "Sleep opties in het onderstaande vak om te sorteren"
        },
        ranking: {
            instruction: {
                responsive: "Selecteer of sleep de opties hieronder naar dit vak om te beginnen met rangschikken",
                default: "Selecteer of sleep de opties naar dit vak om te beginnen met rangschikken"
            }
        },
        allOptionsRanked: "Alle opties zijn gerangschikt",
        allOptionsSorted: "Alle opties zijn gesorteerd",
        select: {
            bucket: "Selecteer een bucket",
            default: "Selecteer"
        },
        action: {
            processOption: "Optie verwerken",
            moveUp: "Verplaats optie omhoog",
            moveDown: "Verplaats optie omlaag",
            removeOption: "Optie verwijderen"
        }
    },

    fi: {
        sorting: {
            dropdownInstruction: "Lajittele kohteet pudotusvalikolla",
            specifyBucket: "Määritä kohderyhmä, johon haluat sijoittaa kukin vaihtoehto:",
            instruction: "Vedä vaihtoehdot alla olevaan laatikkoon järjestääksesi ne"
        },
        ranking: {
            instruction: {
                responsive: "Valitse tai vedä vaihtoehdot alla olevaan laatikkoon aloittaaksesi sijoittelun",
                default: "Vedä vaihtoehdot tähän laatikkoon aloittaaksesi sijoittelun"
            }
        },
        allOptionsRanked: "Kaikki vaihtoehdot on sijoiteltu",
        allOptionsSorted: "Kaikki vaihtoehdot on järjestetty",
        select: {
            bucket: "Valitse kohderyhmä",
            default: "Valitse"
        },
        action: {
            processOption: "Käsittele vaihtoehto",
            moveUp: "Siirrä vaihtoehto ylös",
            moveDown: "Siirrä vaihtoehto alas",
            removeOption: "Poista vaihtoehto"
        }
    },

    hi: {
        sorting: {
            dropdownInstruction: "ड्रॉपडाउन मेनू का उपयोग करके आइटम सॉर्ट करें",
            specifyBucket: "कृपया उस बकेट को निर्दिष्ट करें जहाँ आप प्रत्येक विकल्प रखना चाहते हैं:",
            instruction: "सॉर्ट करने के लिए नीचे दिए गए बॉक्स में विकल्पों को खींचें"
        },
        ranking: {
            instruction: {
                responsive: "रैंकिंग शुरू करने के लिए नीचे दिए गए बॉक्स में विकल्पों का चयन करें या खींचें",
                default: "रैंकिंग शुरू करने के लिए विकल्पों को इस बॉक्स में खींचें"
            }
        },
        allOptionsRanked: "सभी विकल्प रैंक किए गए हैं",
        allOptionsSorted: "सभी विकल्प सॉर्ट किए गए हैं",
        select: {
            bucket: "कृपया बकेट चुनें",
            default: "कृपया चुनें"
        },
        action: {
            processOption: "विकल्प संसाधित करें",
            moveUp: "विकल्प ऊपर ले जाएँ",
            moveDown: "विकल्प नीचे ले जाएँ",
            removeOption: "विकल्प हटाएँ"
        }
    },

    it: {
        sorting: {
            dropdownInstruction: "Ordina gli elementi usando il menu a discesa",
            specifyBucket: "Si prega di specificare il bucket in cui desideri posizionare ogni opzione:",
            instruction: "Trascina le opzioni nella casella sottostante per ordinare"
        },
        ranking: {
            instruction: {
                responsive: "Seleziona o trascina le opzioni di seguito in questa casella per iniziare a classificarle",
                default: "Seleziona o trascina le opzioni in questa casella per iniziare a classificarle"
            }
        },
        allOptionsRanked: "Tutte le opzioni sono state classificate",
        allOptionsSorted: "Tutte le opzioni sono state ordinate",
        select: {
            bucket: "Seleziona un bucket",
            default: "Seleziona"
        },
        action: {
            processOption: "Elabora opzione",
            moveUp: "Sposta opzione in alto",
            moveDown: "Sposta opzione in basso",
            removeOption: "Rimuovi opzione"
        }
    },

    ja: {
        sorting: {
            dropdownInstruction: "ドロップダウンメニューを使用して項目を並べ替える",
            specifyBucket: "各オプションを配置するバケツを指定してください：",
            instruction: "並べ替えるには、下のボックスにオプションをドラッグしてください"
        },
        ranking: {
            instruction: {
                responsive: "このボックスにオプションを選択するかドラッグしてランク付けを開始してください",
                default: "このボックスにオプションをドラッグしてランク付けを開始してください"
            }
        },
        allOptionsRanked: "すべてのオプションがランク付けされました",
        allOptionsSorted: "すべてのオプションが並べ替えられました",
        select: {
            bucket: "バケツを選択してください",
            default: "選択してください"
        },
        action: {
            processOption: "オプションを処理",
            moveUp: "オプションを上に移動",
            moveDown: "オプションを下に移動",
            removeOption: "オプションを削除"
        }
    },

    ko: {
        sorting: {
            dropdownInstruction: "드롭다운 메뉴를 사용하여 항목 정렬",
            specifyBucket: "각 옵션을 배치할 버킷을 지정하세요:",
            instruction: "옵션을 아래 상자로 드래그하여 정렬하세요"
        },
        ranking: {
            instruction: {
                responsive: "이 상자에 옵션을 선택하거나 드래그하여 순위 매기기를 시작하세요",
                default: "이 상자에 옵션을 드래그하여 순위 매기기를 시작하세요"
            }
        },
        allOptionsRanked: "모든 옵션이 순위 매겨졌습니다",
        allOptionsSorted: "모든 옵션이 정렬되었습니다",
        select: {
            bucket: "버킷을 선택하세요",
            default: "선택하세요"
        },
        action: {
            processOption: "옵션 처리",
            moveUp: "옵션 위로 이동",
            moveDown: "옵션 아래로 이동",
            removeOption: "옵션 제거"
        }
    },

    pl: {
        sorting: {
            dropdownInstruction: "Sortuj elementy za pomocą menu rozwijanego",
            specifyBucket: "Proszę określić koszyk, do którego ma zostać umieszczona każda opcja:",
            instruction: "Przeciągnij opcje w poniższe pole, aby posortować"
        },
        ranking: {
            instruction: {
                responsive: "Wybierz lub przeciągnij opcje poniżej do tego pola, aby rozpocząć ranking",
                default: "Wybierz lub przeciągnij opcje do tego pola, aby rozpocząć ranking"
            }
        },
        allOptionsRanked: "Wszystkie opcje zostały ocenione",
        allOptionsSorted: "Wszystkie opcje zostały posortowane",
        select: {
            bucket: "Proszę wybrać koszyk",
            default: "Proszę wybrać"
        },
        action: {
            processOption: "Przetwarzaj opcję",
            moveUp: "Przenieś opcję w górę",
            moveDown: "Przenieś opcję w dół",
            removeOption: "Usuń opcję"
        }
    },

    pt: {
        sorting: {
            dropdownInstruction: "Classifique os itens usando o menu suspenso",
            specifyBucket: "Por favor, especifique o bucket onde você gostaria de colocar cada opção:",
            instruction: "Arraste as opções na caixa abaixo para classificar"
        },
        ranking: {
            instruction: {
                responsive: "Selecione ou arraste as opções abaixo para essa caixa para começar a ranquear",
                default: "Selecione ou arraste as opções para essa caixa para começar a ranquear"
            }
        },
        allOptionsRanked: "Todas as opções foram ranqueadas",
        allOptionsSorted: "Todas as opções foram classificadas",
        select: {
            bucket: "Por favor selecione um bucket",
            default: "Por favor selecione"
        },
        action: {
            processOption: "Processar opção",
            moveUp: "Mover opção para cima",
            moveDown: "Mover opção para baixo",
            removeOption: "Remover opção"
        }
    },

    es: {
        sorting: {
            dropdownInstruction: "Ordena los elementos usando el menú desplegable",
            specifyBucket: "Por favor especifica la categoría donde te gustaría colocar cada opción:",
            instruction: "Arrastra las opciones en el cuadro de abajo para ordenar"
        },
        ranking: {
            instruction: {
                responsive: "Selecciona o arrastra las opciones abajo en este cuadro para comenzar a rankearlas",
                default: "Selecciona o arrastra las opciones en este cuadro para comenzar a rankearlas"
            }
        },
        allOptionsRanked: "Todas las opciones han sido clasificadas",
        allOptionsSorted: "Todas las opciones han sido ordenadas",
        select: {
            bucket: "Por favor selecciona categoría",
            default: "Por favor selecciona"
        },
        action: {
            processOption: "Procesar opción",
            moveUp: "Mover opción hacia arriba",
            moveDown: "Mover opción hacia abajo",
            removeOption: "Eliminar opción"
        }
    },

    tr: {
        sorting: {
            dropdownInstruction: "Öğe sıralamak için açılır menüyü kullanın",
            specifyBucket: "Her seçeneği yerleştirmek istediğiniz kovayı lütfen belirtin:",
            instruction: "Sıralamak için seçenekleri aşağıdaki kutuya sürükleyin"
        },
        ranking: {
            instruction: {
                responsive: "Sıralamaya başlamak için seçenekleri seçin veya bu kutuya sürükleyin",
                default: "Sıralamaya başlamak için seçenekleri bu kutuya sürükleyin"
            }
        },
        allOptionsRanked: "Tüm seçenekler sıralandı",
        allOptionsSorted: "Tüm seçenekler düzenlendi",
        select: {
            bucket: "Lütfen kova seçin",
            default: "Lütfen seçin"
        },
        action: {
            processOption: "Seçeneği işle",
            moveUp: "Seçeneği yukarı taşı",
            moveDown: "Seçeneği aşağı taşı",
            removeOption: "Seçeneği kaldır"
        }
    },

    vi: {
        sorting: {
            dropdownInstruction: "Sắp xếp mục bằng menu thả xuống",
            specifyBucket: "Vui lòng chỉ định nhóm (bucket) mà bạn muốn đặt mỗi tùy chọn:",
            instruction: "Kéo các tùy chọn vào hộp bên dưới để sắp xếp"
        },
        ranking: {
            instruction: {
                responsive: "Chọn hoặc kéo các tùy chọn bên dưới vào hộp này để bắt đầu xếp hạng chúng",
                default: "Chọn hoặc kéo các tùy chọn vào hộp này để bắt đầu xếp hạng chúng"
            }
        },
        allOptionsRanked: "Tất cả tùy chọn đã được xếp hạng",
        allOptionsSorted: "Tất cả tùy chọn đã được sắp xếp",
        select: {
            bucket: "Vui lòng chọn nhóm",
            default: "Vui lòng chọn"
        },
        action: {
            processOption: "Xử lý tùy chọn",
            moveUp: "Di chuyển tùy chọn lên trên",
            moveDown: "Di chuyển tùy chọn xuống dưới",
            removeOption: "Loại bỏ tùy chọn"
        }
    },

    ar: {
        sorting: {
            dropdownInstruction: "رتّب العناصر باستخدام القائمة المنسدلة",
            specifyBucket: "يرجى تحديد المجموعة التي تريد وضع كل خيار فيها:",
            instruction: "اسحب الخيارات في المربع أدناه للترتيب"
        },
        ranking: {
            instruction: {
                responsive: "اختر أو اسحب الخيارات أدناه إلى هذا المربع لبدء ترتيبها",
                default: "اختر أو اسحب الخيارات إلى هذا المربع لبدء ترتيبها"
            }
        },
        allOptionsRanked: "تم ترتيب جميع الخيارات",
        allOptionsSorted: "تم فرز جميع الخيارات",
        select: {
            bucket: "يرجى اختيار مجموعة",
            default: "يرجى الاختيار"
        },
        action: {
            processOption: "معالجة الخيار",
            moveUp: "نقل الخيار لأعلى",
            moveDown: "نقل الخيار لأسفل",
            removeOption: "إزالة الخيار"
        }
    }
};
